(function () {
    const section = document.querySelector('[class="age"]');

    // check if the popup has been shown
    if (localStorage.getItem('mt_user_selected_state')) {
        // redirect if needed
        redirectChecker(localStorage.getItem('mt_user_selected_state'));

        // exit since the state is already selected
        return;
    }

    // open age
    section.showModal();

    // proceed button shows state dropdown
    section.querySelector('.ageActionProceed').addEventListener('click', function () {
        // show state dropdown
        section.querySelector('.ageActionState').classList.add('active');
    });

    // exit button shows error
    section.querySelector('.ageActionExit').addEventListener('click', function () {
        // show error
        section.querySelector('.ageError').classList.add('active');

        // hide state dropdown
        section.querySelector('.ageActionState').classList.remove('active');

        // disable proceed button
        section.querySelector('.ageActionProceed').disabled = true;

        // escape key will not close the dialog
        document.addEventListener('keydown', function (event) {
            event.preventDefault();
        });
    });
    
    // on state change, save to localStorage and close popup
    section.querySelector('.ageActionState').addEventListener('change', function (event) {
      const state = event.target.value;

        // exit if no state selected
        if (!state) return;

        // redirect if needed
        redirectChecker(state);

        // save to localStorage
        localStorage.setItem('mt_user_selected_state', state);

        // close popup
        section.close();
    });
}());